export enum UserRoleEnum {
    ReadOnly = 0,
    Administrator = 1,
    Initiator = 2,
    Validator = 3
}
